export const refreshPhpSession = async (token: string, retryCount = 0): Promise<boolean> => {
    try {
        const response = await fetch('/app/components/auth/login/index.php', {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: `loginJWT=${token}`
        });

        if (!response.ok) {
            // Retry once if failed
            if (retryCount < 1) {
                console.warn('Session refresh failed, retrying...');
                await new Promise(resolve => setTimeout(resolve, 1000)); // Wait 1 second
                return refreshPhpSession(token, retryCount + 1);
            }
            console.error('Session refresh failed after retry');
            return false;
        }

        const data = await response.json();
        
        if (!data.success) {
            console.error('Session refresh response:', data.error?.message || 'Unknown error');
            return false;
        }
        
        return true;
    } catch (error) {
        // Retry on network errors
        if (retryCount < 1) {
            console.warn('Session refresh network error, retrying...');
            await new Promise(resolve => setTimeout(resolve, 1000));
            return refreshPhpSession(token, retryCount + 1);
        }
        console.error('Session refresh error after retry:', error);
        return false;
    }
};